import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import InspectionHomePage from "../InspectionHome/InspectionHome";
import CreateFilledMoundSystemPage from "./CreateFilledMoundSystemForm";
import EditFilledMoundSystemPage from "./EditFilledMoundSystemFormForm";
import HomePage from "../Home/Home";

export const FilledMoundSystemInspectionModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <CreateFilledMoundSystemPage />
        </ProtectedRoute> 
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditFilledMoundSystemPage />
        </ProtectedRoute>
       
        
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default FilledMoundSystemInspectionModule;
